import { vMetricsConstants } from '../constants';

export function vMetrics(state = {}, action) {
  switch (action.type) {
    case vMetricsConstants.GETALL_REQUEST:
      return {
        loading: true
      };
    case vMetricsConstants.GETALL_SUCCESS:
      return {
        items: action.vMetrics
      };
    case vMetricsConstants.GETALL_FAILURE:
      return {
        error: action.error
      };
    default:
      return state
  }
}
